import { BodyItemModel, InitSalesHeaderItemsModel, InitSalesRequestBodyModel } from './initsales_body.model';

export class InitSalesRequestBody {
    Header: InitSalesHeaderItemsModel;
    Body: BodyItemModel;

    constructor(model: InitSalesRequestBodyModel) {
        this.Header = model.Header;
        this.Body = model.Body;
    }
}
